import React from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { RootState, setEmptyAreaConfirmed, setResultMetadata } from "@/store";
import { useTimeTracking } from "@/contexts/TimeTrackingContext";

export const useEmptyAreaQuestion = () => {
  const dispatch = useAppDispatch();
  const { recordQ1Interaction } = useTimeTracking();
  const resultMetadata = useAppSelector(
    (state: RootState) => state.oos.resultMetadata,
  );
  const emptyAreaConfirmed = useAppSelector(
    (state: RootState) => state.oos.emptyAreaConfirmed,
  );

  let emptyAreaRadioValue: "empty" | "not_empty" | null = null;
  if (emptyAreaConfirmed) {
    emptyAreaRadioValue = "empty";
  } else if (resultMetadata.not_empty_area) {
    emptyAreaRadioValue = "not_empty";
  }

  const handleEmptyAreaRadioChange = (value: string) => {
    recordQ1Interaction();
    if (value === "empty") {
      dispatch(setEmptyAreaConfirmed(true));
      dispatch(setResultMetadata({ ...resultMetadata, not_empty_area: false }));
    } else if (value === "not_empty") {
      dispatch(setEmptyAreaConfirmed(null));
      dispatch(
        setResultMetadata({
          ...resultMetadata,
          not_empty_area: true,
          not_main_aisle: false,
          unblurred_person_in_image: false,
          remaining_product_facings: false,
          blue_tag_present: false,
        }),
      );
    }
  };

  const handleQualifierChange =
    (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      recordQ1Interaction();
      dispatch(
        setResultMetadata({
          ...resultMetadata,
          [key]: event.currentTarget.checked,
        }),
      );
    };

  return {
    emptyAreaRadioValue,
    emptyAreaConfirmed,
    resultMetadata,
    handleEmptyAreaRadioChange,
    handleQualifierChange,
  };
};
